import {
    apiExistsInAufschaltung,
    checkApiIdPattern,
    feedExistsForProfileAndApi } from './card_helper'

import { format_en } from './docu/format_en.js';
import { faq } from './docu/faq_en.js';
import { best_practices_en } from './docu/best_practices_en.js';
import { news_en } from './docu/news_en.js';
  
  const cardDefinitionsEn = [
/* Dashboard Cards ID: 1xx-en *************************************************/
// TODO remove if read / show only if new user?
    {
      id: '101-en',
      kind: 'default',
      matches: (context) => {
        return (context.lang === 'en' && context.aufschaltung && !!context.navigation.dashboard)
      },
      title: 'Hello {{ userInfo.nickname }}, welcome at the dpa-infocom API customer portal',
      description: `
  Here you can find all information about the delivery of dpa-infocom content via API.
    * Technical Information like URL endpoints, protocols and credentials
    * Documentation of our formats
    * Test access to our alternative API formats
  
  To get started as fast as possible we recommend reading the <NavLink exact to='/doc/overview'>Overview</NavLink>.
  
  In case there is information missing or you have specific questions, please do not hesitate to <NavLink exact to='/contact'>contact us</NavLink>.
    `,
      data: {with_minify: true}
    },
  /* Use when implemented properly
    {
      id: '102-en',
      kind: 'default',
      matches: (context) => {
        return (context.lang === 'en' && context.aufschaltung && !!context.navigation.dashboard)
      },
      title: 'API-Statistics',
      description: `
  <dashboardfeedstatistics></dashboardfeedstatistics>
    `},
  
    {
      id: '103-en',
      kind: 'default',
      matches: (context) => {
        return (context.lang === 'en' && context.aufschaltung && !!context.navigation.dashboard)
      },
      title: 'Notifications',
      description: `
  <dasboardnotifications></dashboardnotifications>
    `},
  
    {
      id: '104-en',
      kind: 'default',
      matches: (context) => {
        return (context.lang === 'en' && context.aufschaltung && !!context.navigation.dashboard)
      },
      title: 'Logs',
      description: `
  <dashboardlog></dashboardlog>
    `},
  */

/* Profile Cards **************************************************************/
    {
      id: '201-en',
      kind: 'default',
      matches: (context) => {
        return (context.lang === 'en' && context.aufschaltung && context.navigation.profile === 'ALL')
      },
      title: 'What are profiles',
      description: `Profiles are pre-defined selections of dpa content. Profiles might contain
  * one or more Webline headings
  * one ore more dpa-news headings
  * one or more dpa services -- e.g. Basisdienst, Landesdienste or Bildfunk.
    `},
  
    {
      id: '202-en',
      kind: 'default',
      matches: (context) => {
        return (context.lang === 'en' && context.aufschaltung && !!context.navigation.profile && context.navigation.profile !== 'ALL' &&
                !checkApiIdPattern(context, 'api-apigate-'))
      },
      title: 'Content',
      description: `
  Content included in «{{ profile.nickname }}»:
  <ul class="tag_regexp">
  {% if profile.ored_tag_regexps %}
    {% for exp in profile.ored_tag_regexps %}
      <li><Label className='query-bupperl {{exp.kind}}'><span className='kind'>{{exp.kind_title}}</span>{{exp.title}}</Label></li>
    {% endfor %}
  {% elseif profile.query_ored_tag_regexps %}
    {% for exp in profile.query_ored_tag_regexps %}
      <li><Label className='query-bupperl {{exp.kind}}'><span className='kind'>{{exp.kind_title}}</span>{{exp.title}}</Label></li>
    {% endfor %}
  {% endif %}
  </ul>
    `}, // TODO: PROD in sync with DEV cf3 api no ored_tag_regexps needed anymore
  
  /***
    {
      id: '203-en',
      kind: 'default',
      matches: (context) => {
        return (context.lang === 'en' && context.aufschaltung && !!context.navigation.profile && context.navigation.profile !== 'ALL' &&
          !feedExistsForProfileAndApi(context, 'jsonfeed') &&
          !feedExistsForProfileAndApi(context, 's3push'))
      },
      title: 'Hinweis',
      description: `Für das Profil {{ profile.nickname }} ist kein JSON-Feed verfügbar.`,
      data: {
        with_selection: false
      }
    },
  ***/
  
    {
      id: '204-en',
      kind: 'default',
      matches: (context) => {
        return (context.lang === 'en' && context.aufschaltung && !!context.navigation.profile && context.navigation.profile !== 'ALL' &&
          feedExistsForProfileAndApi(context, 'graphql'))
      },
      title: 'Hint',
      description: `The profile {{ profile and profile.nickname }} is available via <NavLink exact to='/api/graphql'>Graphql-API</NavLink>.`
    },
  
    {
      id: '205-en',
      kind: 'default',
      matches: (context) => {
        return (context.lang === 'en' && context.aufschaltung && !!context.navigation.profile && context.navigation.profile !== 'ALL' &&
          feedExistsForProfileAndApi(context, 'graphqlapikp'))
      },
      title: 'Current articles in «{{ profile.nickname }}»',
      description: `
  <feedcontentbrowser></feedcontentbrowser>
    `},

  //  {
  //  id: '206-en',
  //    kind: 'default',
  //    matches: (context) => {
  //      return (context.lang === 'en' && context.aufschaltung && !!context.navigation.profile && context.navigation.profile !== 'ALL' &&
  //        feedExistsForProfileAndApi(context, 'jsonfeed'))
  //    },
  //    title: 'Feed-URL / Abrufbeispiel',
  //    description: `
  //Abruf als JSON-Feed von der Kommandozeile
  //
  //<Message>curl -o - {{ feed and feed.feed_url }}</Message>
  //  `},
  
  //  {
  //    id: '207-en',
  //    kind: 'default',
  //    matches: (context) => {
  //      return (context.lang === 'en' && context.aufschaltung && !!context.navigation.profile && context.navigation.profile !== 'ALL' &&
  //        feedExistsForProfileAndApi(context, 'jsonfeed'))
  //    },
  //    title: 'Dokumentation des Json-Feed-Formats',
  //    description: `Im Bereich API/Json-Feed finden Sie die <NavLink exact to="/doc/overview">Beschreibung des JSON-Feed-Formats</NavLink>.`
  //  },
  
    {
      id: '208-en',
      kind: 'default',
      matches: (context) => {
        return (context.lang === 'en' && context.aufschaltung && !!context.navigation.profile && context.navigation.profile === 'myline-3' &&
          feedExistsForProfileAndApi(context, 'wds'))
      },
      title: 'FTP Access',
      description: `Details of your FTP delivery
  
      * format: nitf
      * host: ftp.customersite.com
      * port 21
      * ftp-mode passive
    
    ### Hint

    Your FTP access to the myline-3 profile is limited until 31.9.2018.

    Please <NavLink exact to='/doc/support-contact'>contact support</NavLink> if you want to customize your contract.`
    },
  
    {
      id: '209-en',
      kind: 'default',
      matches: (context) => {
        return (context.lang === 'en' && context.aufschaltung && context.navigation.api === 's3push')
      },
      title: 's3push-API',
      description: `
  <apis3pushwizard></apis3pushwizard>
    `},

    {
      id: '210-en',
      kind: 'default',
      matches: (context) => {
        return (context.lang === 'en' && context.aufschaltung && !!context.navigation.profile && context.navigation.profile !== 'ALL' &&
          checkApiIdPattern(context, 'api-apigate'))
      },
      title: 'General',
      description: `The data of the profile «{{ profile and profile.nickname }}»
      is available under APIs.
    `},

    {
      id: '211-en',
      kind: 'default',
      matches: (context) => {
        return (context.lang === 'en' && context.aufschaltung && !!context.navigation.profile && context.navigation.profile !== 'ALL' &&
          checkApiIdPattern(context, 'api-apigate-survey'))
      },
      title: 'Content',
      description: `Current survey results. The data of the profile «{{ profile and profile.nickname }}» is available under
      <NavLink exact to='/api/survey'>API | survey</NavLink>.
    `},

    {
      id: '212-en',
      kind: 'default',
      matches: (context) => {
        return (context.lang === 'en' && context.aufschaltung && !!context.navigation.profile && context.navigation.profile !== 'ALL' &&
          checkApiIdPattern(context, 'api-apigate-electionsdata'))
      },
      title: 'Content',
      description: `Current data about elections and polls. The data of the profile «{{ profile and profile.nickname }}» is available under 
      <NavLink exact to='/api/electionsdata'>API | electionsdata</NavLink>.
    `},

    {
      id: '213-en',
      kind: 'default',
      matches: (context) => {
        return (context.lang === 'en' && context.aufschaltung && context.navigation.api === 'sftppush')
      },
      title: 'sftppush-API',
      description: `
  <apisftppushwizard></apisftppushwizard>
    `},

/* API Cards ******************************************************************/
    {
      id: '301-en',
      kind: 'default',
      matches: (context) => {
        return (context.lang === 'en' && context.aufschaltung && context.navigation.api === 'ALL')
      },
      title: 'APIs from dpa-infocom — an overview',
      description: `dpa-infocom offers different APIs for you.

  Depending on the intended use ...
  * json-feed, graphql, notification ...
  * classic NITF via FTP... 
  * ...specific APIs...projektor... 
  
  Learn more about the concrete APIs:
  
  * <Navlink exact to="/api/jsonfeed">Json-Feed</NavLink>
  * <Navlink exact to="/api/s3push">s3push-API</NavLink>
  * <Navlink exact to="/api/annotation">Annotation</NavLink>
  * ...
    `},
  
    {
      id: '302-en',
      kind: 'default',
      matches: (context) => {
        return (context.lang === 'en' && context.aufschaltung && context.navigation.api === 'jsonfeed')
      },
      title: 'Feed-URL',
      description: `
  
  <apifeedurlbrowser></apifeedurlbrowser>
  
    `},
  
    {
      id: '303-en',
      kind: 'default',
      matches: (context) => {
        // only if any feedselection accessible by jsonfeed-api
        return (context.lang === 'en' && context.aufschaltung && context.navigation.api === 'jsonfeed')
      },
      title: 'JSON-Feed-Format',
      description: `The documentation section contains a <Navlink exact to="/doc/overview#what-is-the-jsonfeed-api">description of the JSON feed format</Navlink>.`
    },

    {
      id: '304-en',
      kind: 'default',
      matches: (context) => {
        return (context.lang === 'en' && context.aufschaltung && context.navigation.api === 'jsonfeed')
      },
      title: 'Feed Content',
      description: `
  <apijsoncontentbrowser></apijsoncontentbrowser>
    `},

    {
      id: '305-en',
      kind: 'default',
      matches: (context) => {
        return false // (context.lang === 'en' && context.aufschaltung && context.navigation.api === 'jsonfeed')
      },
      title: 'What are jsonfeeds?',
      description: 'The jsonfeed-API provides a list of the latest messages via a feed URL for retrieval via HTTPS. The JSON-format is used for this purpose ...'
    },

    {
      id: '306-en',
      kind: 'default',
      matches: (context) => {
        return (context.lang === 'en' && context.aufschaltung && context.navigation.api === 'projektor')
      },
      title: 'Projektor-API',
      description: 'The Projektor-API enables you to obtain images in individually definable formats. ....'
    },
  
    {
      id: '307-en',
      kind: 'default',
      matches: (context) => {
        return (context.lang === 'en' && context.aufschaltung && context.navigation.api === 'graphql')
      },
      title: 'Graphql-Endpoint',
      description: `
  Under this URL you can retrieve the contents via graphql.
  
  <Message>{{ feed.graphql_endpoint_url }}</Message>
      `},
  
    {
      id: '308-en',
      kind: 'default',
      matches: (context) => {
        return (context.lang === 'en' && context.aufschaltung && context.navigation.api === 'graphql')
      },
      title: 'Graphql-API',
      description: `
  
  Here you can try the Graphql API.
  
  <apigraphqlbrowser></apigraphqlbrowser>
  `,
      data: {}
    },
  
    {
      id: '309-en',
      kind: 'default',
      matches: (context) => {
        return (context.lang === 'en' && context.aufschaltung && context.navigation.api === 'graphql')
      },
      title: 'How do I use the Graphql API?',
      description: `
  TODO... TODO... TODO... TODO... TODO...TODO...TODO...
  
  ....
  
  TODO... TODO... TODO... TODO... TODO...TODO...TODO...
  `,
      data: {}
    },

    {
      id: '310-en',
      kind: 'default',
      matches: (context) => {
        return (context.lang === 'en' && context.aufschaltung && context.navigation.api === 'annotation')
      },
      title: 'Annotation-Endpoint',
      description: `
  Under this URL you can retrieve annotations via graphql.
  
  <Message>{{ feed.graphql_endpoint_url }}</Message>
      `},
  
    {
      id: '311-en',
      kind: 'default',
      matches: (context) => {
        return (context.lang === 'en' && context.aufschaltung && context.navigation.api === 'annotation')
      },
      title: 'Annotation-Format',
      description: `In the Documentation section you will find a <Navlink exact to="/doc/overview#what-is-the-annotation-api">description of the Annotation-API</Navlink>.`
    },
  
    {
      id: '312-en',
      kind: 'default',
      matches: (context) => {
        return (context.lang === 'en' && context.aufschaltung && context.navigation.api === 'annotation')
      },
      title: 'Annotation-API',
      description: `
  
  Here you can try the Annotation-API.
  
  <apigraphqlbrowser></apigraphqlbrowser>
  `,
      data: {}
    },
  
    {
      id: '313-en',
      kind: 'default',
      matches: (context) => {
        return (context.lang === 'en' && context.aufschaltung && context.navigation.api === 'tryout')
      },
      title: 'tryout-Format',
      description: `In the Documentation section you will find a <Navlink exact to="/doc/overview#what-is-the-tryout-api">description of the tryout-API.</Navlink>.`
    },
  
    {
      id: '314-en',
      kind: 'default',
      matches: (context) => {
        return (context.lang === 'en' && context.aufschaltung && context.navigation.api === 'tryout')
      },
      title: 'Tryout-API',
      description: `
  <apigraphqlbrowser></apigraphqlbrowser>
  `,
      data: {}
    },
  
    {
      id: '315-en',
      kind: 'default',
      matches: (context) => {
        return (context.lang === 'en' && context.aufschaltung && context.navigation.api === 'base')
      },
      title: 'Newslab-Base-API-Endpoint',
      description: `
  Under this URL you can retrieve the topicles from the Newslab-Base-API via graphql.
  
  <Message>{{ feed.graphql_endpoint_url }}</Message>
      `},
  
    {
      id: '316-en',
      kind: 'default',
      matches: (context) => {
        return (context.lang === 'en' && context.aufschaltung && context.navigation.api === 'base')
      },
      title: 'Newslab-Base-API',
      description: `
  
  Here you can try the Newslab-Base-API.
  
  <apigraphqlbrowser></apigraphqlbrowser>
  `,
      data: {}
    },

    {
      id: '317-en',
      kind: 'default',
      matches: (context) => {
        return (context.lang === 'en' && context.aufschaltung && context.navigation.api === 'wireq')
      },
      title: 'wireQ-API',
      description: `
<apiwirequrlbrowser></apiwirequrlbrowser>

  `},


  {
    id: '318-en',
    kind: 'default',
    matches: (context) => {
      return (context.lang === 'en' && context.aufschaltung && context.navigation.api === 'wireq')
    },
    title: 'wireQ-Schema',
    description: `

<Message class="schema-doc-md">
{{ feed.schema_doc_md }}
</Message>

<p>
  The documentation section contains a <Navlink exact to="/doc/overview#what-is-the-wireq-api">description of the wireQ-API</Navlink>.
</p>

  `},

  {
    id: '319-en',
    kind: 'default',
    matches: (context) => {
      return (context.lang === 'en' && context.aufschaltung && context.navigation.api === 'imagewriter')
    },
    title: 'Imagewriter-Endpoint',
    description: `
Under this URL you can retrieve imagewriter via graphql.

<Message>{{ feed.graphql_endpoint_url }}</Message>
  `},

  {
    id: '320-de',
    kind: 'default',
    matches: (context) => {
      return (context.lang === 'en' && context.aufschaltung && context.navigation.api === 'imagewriter')
    },
    title: 'Imagewriter-API',
    description: `

Here you can try the imagewriter graphql API.

<apigraphqlbrowser></apigraphqlbrowser>
`,
    data: {}
  },

  {
    id: '321-en',
    kind: 'default',
    matches: (context) => {
      return (context.lang === 'en' && context.aufschaltung &&
        checkApiIdPattern(context, 'api-apigate') && context.navigation.api &&
        !['wireq', 's3push', 'jsonfeed', 'imagewriter', 'annotation', 'tryout'].some(a => context.navigation.api.includes(a)))
    },
    title: '{{api.nickname}}-API Endpoint',
    description: `
Please use this base-URL to access the {{api.nickname}}-API.

<Message>{{ feed.base_url }}</Message>
  `},

  {
    id: '322-en',
    kind: 'default',
    matches: (context) => {
      return (context.lang === 'en' && context.aufschaltung &&
        checkApiIdPattern(context, 'api-apigate') && context.navigation.api &&
        !['wireq', 's3push', 'jsonfeed', 'imagewriter', 'annotation', 'tryout'].some(a => context.navigation.api.includes(a)))
    },
    title: '{{api.nickname}}-API documentation',
    description: `
<Message class="schema-doc-md">
{{ feed.schema_doc_md }}
</Message>
  `},

  {
    id: '323-en',
    kind: 'default',
    matches: (context) => {
      return (context.lang === 'en' && context.aufschaltung && context.navigation.api === 'survey')
    },
    title: '{{api.nickname}}-API',
    description: `
<p>
  The documentation section contains a <Navlink exact to="/doc/overview#what-is-the-survey-api">description of the survey-API</Navlink>.
</p>
  `},

  {
    id: '324-en',
    kind: 'default',
    matches: (context) => {
      return (context.lang === 'en' && context.aufschaltung && context.navigation.api === 'electionsdata')
    },
    title: '{{api.nickname}}-API brief documentation',
    description: `
<p>
  Details regarding resources and parameters can be found in the <a href="https://swagger.dpa-electionsdata.com" target="_blank">description of electionsdata-API</a>.
</p>

  `},

  {
    id: '325-en',
    kind: 'default',
    matches: (context) => {
      return (context.lang === 'en' && context.aufschaltung && context.navigation.api === 'agenda')
    },
    title: '{{api.nickname}}-API brief documentation',
    description: `
<p>
  Details regarding resources and parameters can be found in the <a href="https://dpa-connect-common-static-pages.s3.eu-central-1.amazonaws.com/agenda/api-doc/index.html" target="_blank">description of {{api.nickname}}-API</a>.
</p>

  `},

      
/* APP Cards ******************************************************************/
    {
      id: '401-en',
      kind: 'default',
      matches: (context) => {
        return (context.lang === 'en' && context.aufschaltung && context.navigation.app === 'ALL')
      },
      title: 'Apps',
      description: 'Please select a specific app from the menu.'
    },
  
    {
      id: '402-en',
      kind: 'default',
      matches: (context) => {
        return (context.lang === 'en' && context.aufschaltung && context.navigation.app === 'cli')
      },
      title: 'dpa-Commandline-Interface',
      description: 'The Command-Line-Interface (dpa-cli) allows the download of feed contents. It is available as nodejs package and is installed locally.\n'
    },
  
    {
      id: '403-en',
      kind: 'default',
      matches: (context) => {
        return (context.lang === 'en' && context.aufschaltung && context.navigation.app === 'cli')
      },
      title: 'Brief introduction to the Commandline-Interface',
      description: `
  
    Install ...
    \`\`\`bash 
    yarn add dpacli 
    \`\`\` 
    Register your credentials ...
    \`\`\`bash 
    dpa config 
    \`\`\` 
    Then you can ...
    \`\`\`bash
    dpa receive 
    \`\`\` 
    The received messages will be ...
    `},
  
    {
      id: '404-en',
      kind: 'default',
      matches: (context) => {
        return (context.lang === 'en' && context.aufschaltung && context.navigation.app === 'showcase')
      },
      title: 'dpa-Showcase',
      description: `
  In the dpa-Showcase you can view the current contents of your profiles.
  
  <Message>
  <a href="{{ card.data.app_link_url }}" target="_blank">{{ card.data.app_link_url }}</a>
  </Message>
  `,
      data: {
        app_link_url: 'https://showcase.dpa-info.com'
      }
    },
  
    {
      id: '405-en',
      kind: 'default', //  'app-description',
      matches: (context) => {
        return (context.lang === 'en' && context.aufschaltung && context.navigation.app === 'schalttafel')
      },
      title: 'dpa-Schalttafel',
      description: `
  The dpa-Schalttafel is an agency entry system that displays your profiles clearly in columns. Import texts and images simply by drag-and-drop from the control panel into your own CMS.

  <Message>
  <a href="{{ card.data.app_link_url }}" target="_blank">{{ card.data.app_link_url }}</a>
  </Message>
  `,
  
      data: {
        app_link_url: 'https://schalttafel3.dpa-newslab.com'
      }
    },
  
    {
      id: '406-en',
      kind: 'default',
      matches: (context) => {
        return (context.lang === 'en' && context.aufschaltung && context.navigation.app === 'executive')
      },
      title: 'dpa-executive',
      description: `
  
  dpa-executive is a mobile app for iOS, android and web.
  
  <Message>
  <a href="{{ card.data.app_link_url }}" target="_blank">{{ card.data.app_link_url }}</a>
  </Message>
  `,
  
      data: {
        app_link_url: 'https://dpa-executive.com/'
      }
    },
  
    {
      id: '407-en',
      kind: 'default',
      matches: (context) => {
        return (context.lang === 'en' && context.aufschaltung && context.navigation.app === 'probe')
      },
      title: 'probe',
      description: `
  
  probe is a protoypical news-app from the dpa-newlab.
  
  <Message>
  <a href="{{ card.data.app_link_url }}" target="_blank">{{ card.data.app_link_url }}</a>
  </Message>
  `,
      data: {
        app_link_url: 'https://d22rhyjaupeni6.cloudfront.net'
      }
    },
  
/* Doc Cards ******************************************************************/
    {
      id: '601-en',
      kind: 'default',
      matches: (context) => {
        return (context.lang === 'en' && context.navigation.doc === 'intro-api')
      },
      title: 'Introduction to the dpa-API-Welt',
      description: `
  
  <embed id='9b0GL2fXh3A' source='youtube' placeholder='/img/mapisw.png' />
    `},
  
  {
    id: '602-en',
    kind: 'default',
    matches: (context) => {
      return (context.lang === 'en' && context.navigation.contact === 'ALL')
    },
    title: 'Contact',
    description: `
You need help? Our service team will be glad to answer any questions you may have!

Please contact us:

* **Email**: kundenservice.desk@dpa.com
* **Phone**: +49 40 4113-32600
  `},

  {
    id: '603-en',
    kind: 'default',
    matches: (context) => {
      return (context.lang === 'en' && context.navigation.doc === 'ALL')
    },
    title: 'Overview',
    description: `
Here you will find more information on the following topics:

* <Navlink exact to="/doc/overview">Overview</NavLink>
* ...
  `},
  
    {
      id: '604-en',
      kind: 'default',
      matches: (context) => {
        return (context.lang === 'en' && context.navigation.doc === 'overview')
      },
      title: 'What is the dpa-digitalwires format?',
      description: `
<table border="0">
  <tr>
    <td align=justify valign=top><p>The dpa-digitalwires format is a JSON-based data
    format that transports multimedia news content from dpa and other agencies.
    This includes in particular:</p>
<ul><li>dpa-Weblines</li><li>dpa-Textfunk</li><li>dpa-Bildfunk</li></ul>
<p>
The dpa-digitalwires format describes the so-called <strong>Topicles</strong>.
Topicles unite aspects of multimedia articles and containers.
</p>
<p>
Therefore purely textual articles, multimedia articles with text and images
as well as aggregates of several texts and any other assets can be represented
as one coherent JSON object.
</p>
<p>
The dpa-digitalwires format suits the requirements for the import into
editorial systems as well as for automatic publication.

Further reading:
* <Navlink exact to="/doc/format">Documentation of the dpa-digitalwires format</NavLink>
</p>
   </td>
   <td style="padding: 0 0 0 20px;">
     <img src="/img/grafik-dw-format.png">
   </td>
  </tr>
 </table>
    `},

    {
      id: '605-en',
      kind: 'default',
      matches: (context) => {
        return (context.lang === 'en' && context.navigation.doc === 'overview' &&
          apiExistsInAufschaltung(context, 's3push'))
      },
      title: 'What is the s3push-API?',
      description: `
S3push transmits new or updated articles directly to any S3 bucket
of the dpa customer. From there, the articles can be picked up regularly or can be
transformed into customer-specific formats using cloud-based functions (AWS-Lambda),
followed by an automatic import process into the customer's CMS.

![s3push-diagramm](/img/s3push-wide.png)

S3push is a modern, cloud-based alternative to FTP Push delivery. It has the advantage that 
there is no need to set up and manage a FTP-Server anymore.

Further reading:
  * <Navlink exact to="/doc/apis#technical-description-of-s3push-api">Technical documentation</NavLink>
  * <Navlink exact to="/doc/s3push-alternative-install">s3push alternative installation methods</NavLink>
  `},

  {
    id: '606-en',
    kind: 'default',
    matches: (context) => {
      return (context.lang === 'en' && context.navigation.doc === 'overview' &&
        apiExistsInAufschaltung(context, 'wireq'))
    },
    title: 'What is the wireQ-API?',
    description: `
The wireQ-API allows you to display all current articles of a profile, including metadata
and links to individual image formats via a queue-based delivery.

The queue contains all the articles that have not yet been imported and can be
retrieve via a simple resttful request. After a successful import, the articles
are removed from the queue.

![wireq-diagramm](/img/wireq-wide.png)

In comparison to the jsonfeed, the effort of recognizing new articles which need
to be imported is reduced on the importer side. Furthermore the transferred data
volume is lower.

In case of a failure of the importer, the articles are reliably stored in the
queue, even for several days.

Further reading:
  * <Navlink exact to="/doc/apis#technical-description-of-the-wireq-api">Technical documentation</NavLink>
    `},

    {
      id: '607-en',
      kind: 'default',
      matches: (context) => {
        return (context.lang === 'en' && context.navigation.doc === 'overview' &&
          apiExistsInAufschaltung(context, 'jsonfeed'))
      },
      title: 'What is the jsonfeed-API?',
      description: `
The jsonfeed-API allows you to retrieve all current articles of a profile
including metadata and links to individual image formats with a simple HTTP request.

These feeds are very similar in structure to the well-known Atom-XML or RSS-Feeds.
However, the data format used here is JSON.

The feeds can be retrieved from the backend of the dpa customer via HTTP-GET.
Depending on the requirements of the up-to-date state on the customer side, the
jsonfeed should be polled regularly in intervals of 30 seconds to several minutes (conditional request).

![jsonfeed-diagramm](/img/jsonfeed-wide.png)

Further reading:
  * <Navlink exact to="/doc/apis#technical-description-of-the-jsonfeed-api">Technical documentation</NavLink>
  `},
  
    {
      id: '608-en',
      kind: 'default',
      matches: (context) => {
        return (context.lang === 'en' && context.navigation.doc === 'overview' &&
          apiExistsInAufschaltung(context, 'projektor'))
      },
      title: 'What is Projektor?',
      description: `
  Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et
  dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet
  
    * Kundenspezifische Bildformate
    * Kundenspezifische Metadaten
  
  Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et
  dolore magna aliquyam erat, sed diam voluptua.
    `},

    {
      id: '609-en',
      kind: 'default',
      matches: (context) => {
        return (context.lang === 'en' && context.navigation.doc === 'overview' &&
          apiExistsInAufschaltung(context, 'graphql'))
      },
      title: 'What is GraphQL-API?',
      description: `
  Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et
  dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet
  
  Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et
  dolore magna aliquyam erat, sed diam voluptua.
    `},

    {
      id: '610-en',
      kind: 'default',
      matches: (context) => {
        return (context.lang === 'en' && context.navigation.doc === 'overview' &&
          apiExistsInAufschaltung(context, 'annotation'))
      },
      title: 'What is the Annotation-API?',
      description: `
Über die Annotation-API können dpa-Kunden ergänzende Informationen zu Artikeln abrufen,
die sie via s3push, wireq, jsonfeed oder andere Wege erhalten haben. Der initiale Use Case ist die Auslieferung von Performant Content Metadaten an Weblineskunden, die die Inhalte noch per FTP im Format NITF beziehen.

Die Annotation-API basiert auf GraphQL. Hierbei können die API-User auf der Grundlage
eines Schemas selber festlegen, welche Attribute sie abrufen wollen.
Die Annotation-API lässt sich direkt im API-Portal ausprobieren.
(Siehe <NavLink exact to="/api/annotation">API | annotation</NavLink>)

Der Ablauf sieht auf Seiten des dpa-Kunden so aus:

* Artikel-ID ermitteln
* GraphQL-Anfrage stellen
* Ergebnis auswerten

![annotation-api-diagramm](/img/annotation-wide.png)

Mehr zum Thema
  * <Navlink exact to="/doc/apis#annotation">Dokumentation Annotation-API</NavLink>
  `},

    {
      id: '611-en',
      kind: 'default',
      matches: (context) => {
        return (context.lang === 'en' && context.navigation.doc === 'overview' &&
          apiExistsInAufschaltung(context, 'tryout'))
      },
      title: 'What is the tryout-API?',
      description: `
Tryout-API is a GraphQL API for testing and development inside of dpa-newslab.
    `},
  
    {
      id: '612-en',
      kind: 'default',
      matches: (context) => {
        return (context.lang === 'en' && context.navigation.doc === 'overview' &&
          apiExistsInAufschaltung(context, 'base'))
      },
      title: 'What is the base-API?',
      description: `
The base-API is a GraphQL API that makes various objects of news production accessible at dpa.

The base-API is to be iteratively extended by more and more areas of application.

First steps:
  * Simple Topicles from Tank
  * Image Retrieval
  * Topicle Search
  * Blockchain for everything
  * Transmission of sports results by quantum entanglement
  
  `},

  {
    id: '613-en',
    kind: 'default',
    matches: (context) => {
      return (context.lang === 'en' && context.navigation.doc === 's3push-alternative-install')
    },
    title: 'Alternative installation methods to s3push',
    description: `
  #### Manual Setup in the AWS-Console
  
  The manual setup of s3push using the AWS-Console is described below.
  This installation is sufficient for an easy delivery with s3push.

  We recommend the sample projects based on serverless.yml in case you want to convert
  the received JSON-articles into a different format using a lambda function or
  you want to notify subsequent systems.
  This will save you a lot of time for the setup.
  
  #### 1. Create S3 bucket
  
  In the  <a href="https://s3.console.aws.amazon.com/s3" target="_blank">AWS S3-Console</a>
  
  #### 2. Create a new IAM-User
  
  In the <a href="https://console.aws.amazon.com/iam/home#/users" target="_blank">AWS Identity and Access Management (IAM)</a>
  
  * Access type -> Programmatic access
  * Set permissions -> Attach policies directly -> Create policy
  
  #### 3. Create Policy 
  
  In the <a href="https://console.aws.amazon.com/iam/home#/policies" target="_blank">AWS IAM-Console Policies</a>
  
  After resource adjustments ({s3_s3push_bucket_name} and {s3_s3push_prefix})
  the following minimal policy can be inserted under the "JSON"-tab:
  \`\`\`bash
  {
    "Version": "2012-10-17",
    "Statement": [
      {
        "Sid": "Statement1",
        "Effect": "Allow",
        "Action": [
          "s3:PutObject",
          "s3:GetObject",
          "s3:GetBucketLocation"
        ],
        "Resource": [
          "arn:aws:s3:::{s3_s3push_bucket_name}",
          "arn:aws:s3:::{s3_s3push_bucket_name}/{s3_s3push_prefix}*"
        ]
      }
    ]
  }
  \`\`\`
  
  #### 4. Cross-Origin Resource Sharing (CORS) Configuration
  To display the preview of the data from the respective S3 bucket, cross-domain
  resource sharing with CORS must be activated (S3 bucket -> Permissions -> Cross-origin resource sharing (CORS)).
  
  For this the following settings are necessary:
  
  (see also <a href="https://docs.aws.amazon.com/de_de/AmazonS3/latest/user-guide/add-cors-configuration.html" target="_blank">AWS-Documentation to S3-CORS</a>)
  
  \`\`\`json
    [
        {
            "AllowedHeaders": [
                "*"
            ],
            "AllowedMethods": [
                "GET",
                "HEAD"
            ],
            "AllowedOrigins": [
                "*"
            ],
            "ExposeHeaders": [],
            "MaxAgeSeconds": 3000
        }
    ]
  \`\`\`
  
  #### 5. Transfer data
  After the respective user has been created with the specified policy ,
  the required data (Access key ID and Secret access key) can be created and transferred
  to the API portal by copying and pasting.

    `},

    {
      id: '614-en',
      kind: 'default',
      matches: (context) => {
        return (context.lang === 'en' && context.navigation.doc === 'apis')
      },
      title: 'API-Comparison',
      description: `
<table border=1 cellspacing=0 cellpadding=10>
  <tr>
    <th></th>
    <th>s3push-API</th>
    <th>wireQ-API</th>
    <th>jsonfeed-API</th>
  </tr>
  <tr>
    <td valign=top><strong>Format variants</strong></td>
    <td valign=top>JSON (further formats possible through transformation function on customer side)</td>
    <td valign=top>JSON</td>
    <td valign=top>JSON/RSS</td>
  </tr>
  <tr>
    <td valign=top><strong>Scenario</strong></td>
    <td valign=top>event-based</td>
    <td valign=top>restful-queue</td>
    <td valign=top>restful</td>
  </tr>
  <tr>
    <td valign=top><strong>Delivery principle</strong></td>
    <td valign=top>The data is transferred to an S3 bucket provided by the customer</td>
    <td valign=top>The client receives data from the cloud-based queue</td>
    <td valign=top>time-delayed (or rubric-based) aggregation by having the client poll the API</td>
  </tr>
  <tr>
    <td valign=top><strong>Transported data sets</strong></td>
    <td valign=top>only new or updated topicles</td>
    <td valign=top>only new or updated topicles</td>
    <td valign=top>always all topicles of the feed</td>
  </tr>
  <tr>
    <td valign=top><strong>import into CMS</strong></td>
    <td valign=top>simple import, because only new or updated topicles come in</td>
    <td valign=top>simple import, because only new or updated topicles come in</td>
    <td valign=top>high effort for the detection of new topicles to be imported, since all topicles of the feed are always transmitted</td>
  </tr>
  <tr>
    <td valign=top><strong>Costs</strong></td>
    <td valign=top>favourable</td>
    <td valign=top>mean</td>
    <td valign=top>high</td>
  </tr>
  </table>
    `},

    {
      id: '615-en',
      kind: 'default',
      matches: (context) => {
        return (context.lang === 'en' && context.navigation.doc === 's3push-scenarios')
      },
      title: 'Application scenarios s3push',
      description: `
Im Folgenden werden verschiedene Anwendungsszenarien für s3push dargestellt.

#### CMS-Import aus S3

Vielen aktuelle Weblines-Kunden nutzen die Import-Funktionalität ihres CMS um Weblines
und dpa Meldungen aus dem Dateisystem des FTP Servers zu importieren.
Der Import erfolgt zumeist zeit- in fortgeschritteneren Fällen auch eventgesteuert
und beinhaltet in der Regel eine Formattransformation in das Importformat des CMS.

AWS S3 (Simple Storage System) ist der defacto Standard für cloudbasierte Dateispeicher.
Diese bieten neben der Tatsache, dass Sie praktisch nicht vollaufen können
(ein häufiges Problem bei FTP Servern) eingebaute Sicherheit durch die Verwendung von HTTPS.

Die Möglichkeit, dass beim Anlegen einer neuen Datei eine Lambdafunktion aufgerufen
werden kann, erlaubt es, sowohl Formattransformationen, als auch Notifikationen an
das CMS resp. andere nachgelagerte Systeme vorzunehmen.
    `},

      // ------------------------ s3push deep-dive 
    {
      id: '616-en',
      kind: 'default',
      matches: (context) => {
        return (context.lang === 'en' && context.navigation.doc === 'apis' &&
                apiExistsInAufschaltung(context, 's3push'))
      },
      title: 'Technical description of s3push-API',
      description: `
### Overview
S3push is a modern, cloud-based alternative to delivery via FTP push.
There is no need to operate an FTP server yourself.

S3push transfers new or updated articles directly into the dpa client's S3 bucket.

Each article is stored in a JSON representation (see below) under its own key.
The key contains a timestamp and a hash so that updates receive their own key.

In order to further process the incoming articles, a lambda function can be
bound to the bucket. If a new article arrives, the function is called. In this
way, format conversions and triggers can be programmed.

We have prepared some code examples for this (see section "Creating conversion functions").

![s3push-diagramm](/img/s3push-wide.png)

#### Best Practices

On Github, the dpa-newslab has published a couple of best practices for working with the s3push API:

* <NavLink exact to="/doc/best-practices#s3push-connection">s3push connection</NavLink>

#### Comparison s3push with FTP

Features of s3push:
* Data transfer and storage through standardised cloud service (AWS S3)
* High availability, cost-effective service
* No FTP server to operate
* Possibility of cloud-based further processing and triggers (AWS Lambda, SNS, SQS, Kinesis etc.)
  -- The uniform technical basis allows customers to use generic sample solutions.

Features of FTP(-Push): 
* Own hosting or through service provider
* Costs and availability depend on the setting -- are, however, generally higher than with AWS-S3
* Aged protocol
* Trigger mostly via file system events or time-based via cron jobs
  -- no uniform technical basis, each customer must create or commission its own connection.

### Setup on the client side

#### Self-service in the API portal

Customers can set up and manage their own access to s3push. (See <NavLink exact to="/api/s3push">API | s3push</NavLink>)

In our <a href='https://github.com/dpa-newslab' target='_blank'>Github-Repository</a> you will find various <NavLink exact to="/doc/best-practices#s3push-anbindung">best practices</NavLink> based on the <a href='https://www.serverless.com' target='_blank'>serverless-framework</a>.

When you install the best practices, the following infrastructure is automatically
set up for you:
* an S3 bucket with appropriate access right
* a notification mechanism using S3-SNS-SQS
* a conversion function to convert the dpa-digitalwires format into your CMS-compliant format
* a queue that makes the new converted topicles available for your CMS

To receive messages via s3push, you need to create a S3 bucket with appropriate access rights in your AWS account.

You can find the installation instructions in the README file of the <a href='https://github.com/dpa-newslab' target='_blank'>Github repository</a>, you have chosen.

To receive messages via s3push, you need to create an S3 bucket with appropriate access rights
in your AWS account.

Please enter the outputs for **S3 URL Prefix**, **Access Key ID** and **Secret Access Key** in the next step in the form in the API portal.

There are also alternative installation methods.
See <Navlink exact to="/doc/s3push-alternative-install">Alternative installation methods</NavLink>
    `},
  
  // ------------------------ end s3push deep-dive 

  // ------------------------ wireq api deep-dive 
  {
    id: '617-en',
    kind: 'default',
    matches: (context) => {
      return (context.lang === 'en' && context.navigation.doc === 'apis' &&
      apiExistsInAufschaltung(context, 'wireq'))
    },
    title: 'Technical description of the wireQ-API',
    description: `
### Overview

The wireQ API enables the delivery of all topicles of a profile including
metadata and links to individual image formats via a restful queue.
The wireQ URL is available in the API portal. (See <NavLink exact to="/api/wireq">API | wireq</NavLink>)

The queue contains all topicles that have not yet been imported and can be
retrieved by means of a simple restful request. After a successful import,
the topicles are deleted from the queue.

![wireq-diagramm](/img/wireq-wide.png)

Compared to the jsonfeed, the effort required on the importer's side to
recognise new topicles to be imported is reduced. In addition, the amount of
data transferred is smaller.

In case of an importer failure, the topicles are reliably kept in the queue,
even over several days.

#### Best Practices

On Github, the dpa-newslab has published a couple of best practices for working with the wireQ API:

* <NavLink exact to="/doc/best-practices#wireq-connection">wireQ connection</NavLink>

### Comparison wireQ-API with jsonfeed-API

Features of the wireQ-API:
  * a simple HTTP pull request on the customer's side
  * transfer of small amounts of data, as only all topicles that have not yet been imported are retrieved - low effort to recognise new topicles to be imported
  * queue-based delivery
  * in case of a failure, the queue reliably holds topicles that have not yet been called up - even over several days

Features of the jsonfeed-API:
  * a simple HTTP pull request on the customer's side
  * transfer of large data sets, as all topicles are always retrieved - high effort to recognise new topicles to be imported

### Resources:

\`\`\`bash
POST {base}/dequeue-entries.json
\`\`\`

GET and DELETE in one call.

A JSON with a list of articles is returned in the response:
\`\`\`
{ entries: [ {...}, ... ] }
\`\`\`

---

\`\`\`bash
GET {base}/entries.json
\`\`\`

Fetches new entries from the queue and makes them invisible for a certain time
(only a certain amount of entries are fetched per request).

A JSON with a list of articles is returned in the response:

\`\`\`
{ entries: [ {...}, ... ] }
\`\`\`

---

\`\`\`bash
DELETE {base}/entry/{receipt}
\`\`\`

Delete an entry from the queue. The \`{receipt}\` can be found in the attribute
\`_wireq_receipt\` of the respective entry.

---

\`\`\`bash
POST {base}/purge
\`\`\`

Delete all entries from the queue.
   `},

    {
      id: '618-en',
      kind: 'default',
      matches: (context) => {
        return (context.lang === 'en' && context.navigation.doc === 'apis' &&
                apiExistsInAufschaltung(context, 's3push'))
      },
      title: 'Example-Code',
      description: `
  #### GET and DELETE in one request
  
  \`\`\`python
  def simple_receive():
      """ get and delete entries in one step """
      while True:
          partial_feed = wireq.post('dequeue-entries.json')
          for entry in partial_feed['entries']:
              yield entry
          sleep(poll_interval)
  \`\`\`

  #### GET request

  \`\`\`python
  def receive_and_process():
      """ get entries and process, delete only if processing is successful """
      while True:
          partial_feed = wireq.get('entries.json')
          for entry in partial_feed['entries']:
              receipt = entry['receipt']
              ok = process(entry)
              if ok:
                  wireq.delete('entries/'+receipt)
          sleep(poll_interval)
  \`\`\`
     `},
  
    {
      id: '619-en',
      kind: 'default',
      matches: (context) => {
        return (context.lang === 'en' && context.navigation.doc === 'apis' &&
                apiExistsInAufschaltung(context, 'jsonfeed'))
      },
      title: 'Technical description of the jsonfeed-API',
      description: `
### Overview

The jsonfeed API makes it possible to fetch all current topicles of a profile
including metadata and links to individual image formats with a simple HTTP request.

Structurally, the feeds are similar to the familiar Atom XML or RSS feeds.
However, JSON is used here as the data format.

The feeds are fetched from the backend of the dpa client via HTTP GET, so this
is a "pull scenario". Depending on the requirements of up-to-dateness, the feeds should
be polled regularly, at intervals of 30 seconds to several minutes.

![jsonfeed-diagramm](/img/jsonfeed-wide.png)

### Comparison of jsonfeed-API with wireQ-API

Features of the jsonfeed-API:
  * a simple HTTP pull request on the customer's side
  * transfer of large data sets, as all topicles are always retrieved - high effort to recognise new topicles to be imported

Features of the wireQ-API:
* a simple HTTP pull request on the customer's side
* transfer of small amounts of data, as only all topicles that have not yet been imported are retrieved - low effort to recognise new topicles to be imported
* queue-based delivery
* in case of a failure, the queue reliably holds topicles that have not yet been called up - even over several days

### Conditional GET
The jsonfeed must be polled regularly, whereby the feed rarely changes within the
poll interval. To prevent unnecessary polling, we recommend implementing a "Conditional GET".
Here are two examples to illustrate this:

#### Command line:

\`\`\`bash
curl -v -o /dev/null https://XXX.cloudfront.net/XXX/aufschaltung/au-XXX/feed/feed.json
  -->
  ...ETag: "9e764579ab6a873563aa905217f6e061"

curl -v -o /dev/null -H 'If-None-Match: e809ce4015da9234d6cff180511d3a08' https://XXX.cloudfront.net/XXX/aufschaltung/au-XXX/feed/feed.json
  --> HTTP/1.1 304 Not Modified
\`\`\`

#### Python-Example:

\`\`\`python
import requests
from time import sleep


def conditional_request(url):
    poll_interval = 30
    headers = {'Content-Type': 'application/json'}
    while True:
        try:
            response = requests.get(url, headers=headers)
        except Exception as e:
            raise e

        if response.status_code == 304:
            print('The feed has not been modified!')
        resp_headers = response.headers
        etag = resp_headers.get('ETag')
        if etag:
            headers['If-None-Match'] = etag

        sleep(poll_interval)


if __name__ == '__main__':
    url = 'https://XXX.cloudfront.net/XXX/aufschaltung/au-XXX/feed/feed.json'
    conditional_request(url)
\`\`\`

### jsonfeed for client apps

On request, we can set up jsonfeeds that can be accessed by many end customers
with a high load. These jsonfeeds are suitable for easy integration into mobile
apps. Please contact us in this case.

    `},

    {
      id: '620-en',
      kind: 'default',
      matches: (context) => {
        return (context.lang === 'en' && context.navigation.doc === 'jsonfeed-scenarios')
      },
      title: 'Application scenarios jsonfeed',
      description: `
  Im Folgenden werden verschiedene Anwendungsszenarien für jsonfeed dargestellt.
  
     `},

     {
        id: '621-en',
        kind: 'default',
        matches: (context) => {
          return (context.lang === 'en' && context.navigation.doc === 'apis' &&
                apiExistsInAufschaltung(context, 'imagewriter'))
        },
        title: 'Dokumentation Imagewriter-API',
        description: `
First, the identifier of an article (also called "URN" -- universal resource name) must be determined.

In the digitalwires format, this URN is located in the **urn** attribute of the topicle
(see section Format description for the respective API). For webline articles,
the URN is usually in the format: **urn:newsml:dpa.com:20090101:xxxxxx-yy-zzzzzz**

The URN is inserted into the query.

\`\`\`
query {
  simpleImage (urn: "urn:newsml:dpa.com:20090101:200301-99-xxx") {
    headline
    caption
    creditline
    renditions {
      url
    }
  }
}
\`\`\`

The response looks like this:

\`\`\`
{
  "data": {
    "simpleImage": {
      "headline": "Amtsgericht Tiergarten",
      "caption": "Ein Schild mit der Aufschrift «Amtsgericht Tiergarten».",
      "creditline": "Sven Braun/dpa/Archivbild",
      "renditions": [
        {
          "url": "https://dusbyl9uu6btk.cloudfront.net/v3/image/resize/urn:newsml:dpa.com:20090101:200301..."
        }
      ]
    }
  }
}
\`\`\`
  `},

  // ------------------------ annotation api deep-dive 
    {
      id: '622-en',
      kind: 'default',
      matches: (context) => {
        return (context.lang === 'en' && context.navigation.doc === 'apis' &&
                apiExistsInAufschaltung(context, 'annotation'))
      },
      title: 'Technical description of Annotation-API',
      description: `
#### **NOTE**: This page is currently only available in German! The English version will follow soon.

<ul>
<li><NavLink exact to="/doc/annotation-deep-dive#funktionsweise">Funktionsweise</NavLink></li>
<li><NavLink exact to="/doc/annotation-deep-dive#anfragen-mit-der-annotation-api">Anfragen mit der Annotation-API</NavLink></li>
<li><NavLink exact to="/doc/annotation-deep-dive#hinweise-für-weblinekunden">Hinweise für Weblinekunden</NavLink></li>
</ul>


### Funktionsweise

Über die Annotation-API können dpa-Kunden ergänzende Informationen zu Artikeln abrufen,
die sie via s3push, wireQ, jsonfeed oder andere Wege erhalten haben.
Der initiale Use Case ist die Auslieferung von Performant Content Metadaten an Weblineskunden,
die die Inhalte noch per FTP im Format NITF beziehen.

Die Annotation-API basiert auf GraphQL. Hierbei können die API-User auf der Grundlage
eines Schemas selber festlegen, welche Attribute sie abrufen wollen.
Die Annotation-API lässt sich direkt im API-Portal ausprobieren.
(Siehe <NavLink exact to="/api/annotation">API | annotation</NavLink>)

Der Ablauf sieht auf Seiten des dpa-Kunden so aus:

* Artikel-ID ermitteln
* GraphQL-Anfrage stellen
* Ergebnis auswerten

![annotation-api-diagramm](/img/annotation-wide.png)


### Anfragen mit der Annotation-API

#### Use Case Abruf von „Performant Content Metadaten”

Im Folgenden wird beispielhaft beschrieben, wie im Zusammenhang mit dem Abruf von
„Performant Content Metadaten” die Werte **limbicsystem**, **lifetime** oder **importance**
eines Artikels abgerufen werden.

Es sollen abgefragt werden:

* die addressierte Zielgruppe eines Artikels im **limbicsystem**
* die „Wichtigkeit” des Artikels: **importance**
* die „Lebensdauer” des Artikels **lifetime**

Dazu muss zunächst der Identifier eines Artikels (auch genannt "URN" -- universal ressource name) ermittelt werden. 

Im digitalwires-Format befindet sich dieser URN im Attribut **urn** des Topicles (siehe Abschnitt Formatbeschreibung bei der jeweiligen API). Die URN hat bei Weblinesartikeln in der Regel das Format: **urn:newsml:dpa.com:20090101:xxxxxx-yy-zzzzzz**

Existierende Weblineskunden, die die Weblines via FTP und NITF beziehen, beachten
bitte die [Hinweise für Weblinekunden](#hinweise-für-weblinekunden) am Ende.

Der URN wird in das Query eingesetzt (wobei Sie auch eine Liste von URNs angeben können).
Im Beispiel verwenden wir die URN eines Testartikels.

\`\`\`
query {
 get_annotations(urns:["urn:dnltest:advicedemo:201901:001"]) {
    items {
      ... on Advice {
        type
        subject { urn }
        limbicsystem {qcode }
        lifetime { qcode }
        importance { qcode }
      }
    }
  }
}
\`\`\`

Die Response sieht folgendermaßen aus:

\`\`\`
 {
  "data": {
    "get_annotations": {
      "items": [
        {
          "type": "dnltype:publishadvice",
          "subject": {
            "urn": "urn:dnltest:advicedemo:201901:001"
          },
          "limbicsystem": {
            "qcode": "dpa-limbic-system:dominance"
          },
          "lifetime": {
            "qcode": "advice-lifetime:long"
          },
          "importance": {
            "qcode": "advice-importance:useful"
          }
        }
      ]
    }
  }
}
\`\`\`

Die so erhaltenen Werte können Sie dann in ihr CMS oder ein anderes internes System übernehmen.

### Hinweise für Weblinekunden

 * Um ihnen die Nutzung der Annotation-API einfacher zu machen, unterstützen wir auch das ID-Format der Weblines, das Sie im Wert des **id-string**-Attributes des \`<doc-id>\`-Tags finden.
 * Diese ID hat typischerweise das Format: **urn-newsml-dpa-com-20090101-xxxxxx-yy-zzzzzz:iiiiiiiiiiiii**

     `},


  {
    id: '623-en',
    kind: 'default',
    matches: (context) => {
      return (context.lang === 'en' && context.navigation.doc === 'overview' &&
      apiExistsInAufschaltung(context, 'electionsdata'))
    },
    title: 'What is the electionsdata-API?',
    description: `
The electionsdata-API allows access to elections-related data via a restful API, especially:
  * election results
  * polls
  * candidates
  * events and detailed information

The electionsdata-URL is available in the API-Portal. (See <NavLink exact to="/api/electionsdata">API | electionsdata</NavLink>)

Details regarding resources and parameters can be found in the <a href="https://swagger.dpa-electionsdata.com" target="_blank">description of electionsdata-API</a>.

`},

/*****      
  {
    id: '623-en',
    kind: 'default',
    matches: (context) => {
      return (context.lang === 'en' && context.navigation.doc === 'overview' &&
      apiExistsInAufschaltung(context, 'survey'))
    },
    title: 'What is the survey-API?',
    description: `
The Survey API allows access to survey results via a Restful-API.
The survey-URL is available in the API-Portal. (See <NavLink exact to="/api/survey">API | survey</NavLink>)

### GET <base>/surveys?<parameters>   

The API returns survey data for each European Parliament and for a period of up to 4 years (only Bundestag),
depending on the request parameters. The data comes in JSON format, a documentation of the structure can be
found <NavLink exact to='/res/survey_response.txt' target='_blank'>here</NavLink>.

### example url 

  <base>/surveys?source=source21&minified=false&office=at_1&date=2019-03-16 

### parameters

- **office** (string)  
Determines for which parliament the survey data should be issued. If office is not transferred, the default value de_1 (Bundestag) is used.
A list of IDs for the parliaments can be found here.
- **date** (string - optional)
Determines the period of time for which survey data should be returned. If date is not transferred, survey data for the last 12 months will be returned. Possible values are: 
    - YYYY-MM-DD --> Past date.  Example: date=2020-01-01 returns surveys between 1.1.2020 and the day of the API request.
    - lastElection --> This returns surveys since the last election of the country, including the last election result. If the election was less than 12 months ago, the surveys of the last 12 months are returned.
- **lastSurvey** (boolean - optional)   
Determines, whether the survey right before the requested date should be returned. The default value is false.
-	**source** (string - optional)  
Determines, on which sources the surveys should be based. Possible values are:
    - latest --> The surveys of the institute that published the latest survey are returned. This is the default value.
    - all --> The surveys of all institutes from which surveys have been published over a longer period of time are returned.
    - sourceXX --> Only the surveys of a specific institute are displayed. The sources that are available for a parliament are listed in the API response. Please contact us if you need the ID for a specific institute.
- **language** (string - optional)  
Determines the language in which the names for the parties, the institutes and the parliament are displayed. Possible values:
    - de --> default
    - en
- **minified** (boolean - optional)  
Determines the data extent of the surveys. If minified=true is passed, only the party-IDs are returned, but not the colours and names of the parties. Can be used if own party names and colours are to be used and mapped based on the IDs. The default value is false.

`},
****/

      
{
  id: '624-en',
  kind: 'default',
  matches: (context) => {
    return (context.lang === 'en' && context.navigation.doc === 'format')
  },
  title: 'The dpa-digitalwires format',
  description: format_en
},

// ------------------------ faq
{
  id: '625-en',
  kind: 'default',
  matches: (context) => {
    return (context.lang === 'en' && context.navigation.doc === 'faq')
  },
  title: 'FAQ',
  description: faq
},
// ------------------------ best practices
{
  id: '626-en',
  kind: 'default',
  matches: (context) => {
    return (context.lang === 'en' && context.navigation.doc === 'best-practices')
  },
  title: 'Best Practices',
  description: best_practices_en
},

{
  id: '627-en',
  kind: 'default',
  matches: (context) => {
    return (context.lang === 'en' && context.navigation.doc === 'overview' &&
      apiExistsInAufschaltung(context, 'sftppush'))
  },
  title: 'What is the sftppush-API?',
  description: `
Sftppush transfers new or updated articles directly to the dpa customer's SFTP server. From there, the articles can be picked up regularly.

Mehr zum Thema:
  * <Navlink exact to="/doc/apis#documentation-sftppush-api">Documentation sftppush-API</NavLink>
`},
  // ------------------------ sftppush deep-dive 
  {
    id: '628-en',
    kind: 'default',
    matches: (context) => {
      return (context.lang === 'en' && context.navigation.doc === 'apis' &&
      apiExistsInAufschaltung(context, 'sftppush'))
    },
    title: 'Technical documentation sftppush-API',
    description: `
### Overview
Sftppush transfers new or updated articles directly to the dpa customer's SFTP server.

  `},

    // ------------------------ news
    {
      id: '629-en',
      kind: 'default',
      matches: (context) => {
        return (context.lang === 'en' && context.navigation.doc === 'news')
      },
      title: 'News',
      description: news_en
    }
  ]

  export { cardDefinitionsEn }



// WEBPACK FOOTER //
// ./src/all_cards/card_definitions_en.js